import { render, staticRenderFns } from "./secondary-kpi-form.vue?vue&type=template&id=0c9706a2"
import script from "./secondary-kpi-form.vue?vue&type=script&lang=ts"
export * from "./secondary-kpi-form.vue?vue&type=script&lang=ts"
import style0 from "./secondary-kpi-form.vue?vue&type=style&index=0&id=0c9706a2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9706a2')) {
      api.createRecord('0c9706a2', component.options)
    } else {
      api.reload('0c9706a2', component.options)
    }
    module.hot.accept("./secondary-kpi-form.vue?vue&type=template&id=0c9706a2", function () {
      api.rerender('0c9706a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/secondary-kpi-tab/secondary-kpi-lightbox/secondary-kpi-form/secondary-kpi-form.vue"
export default component.exports